import {
  getDiscount as publicGetDiscount,
  updateDiscount as publicUpdateDiscount,
  createDiscount as publicCreateDiscount,
  listDiscounts as publicListDiscounts,
} from './restaurants-catalogs-v3-discount-discount.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onDiscountCreated as publicOnDiscountCreated } from './restaurants-catalogs-v3-discount-discount.public.js';
import { onDiscountUpdated as publicOnDiscountUpdated } from './restaurants-catalogs-v3-discount-discount.public.js';

export const getDiscount: MaybeContext<
  BuildRESTFunction<typeof publicGetDiscount> & typeof publicGetDiscount
> = /*#__PURE__*/ createRESTModule(publicGetDiscount);
export const updateDiscount: MaybeContext<
  BuildRESTFunction<typeof publicUpdateDiscount> & typeof publicUpdateDiscount
> = /*#__PURE__*/ createRESTModule(publicUpdateDiscount);
export const createDiscount: MaybeContext<
  BuildRESTFunction<typeof publicCreateDiscount> & typeof publicCreateDiscount
> = /*#__PURE__*/ createRESTModule(publicCreateDiscount);
export const listDiscounts: MaybeContext<
  BuildRESTFunction<typeof publicListDiscounts> & typeof publicListDiscounts
> = /*#__PURE__*/ createRESTModule(publicListDiscounts);
/** */
export const onDiscountCreated: BuildEventDefinition<
  typeof publicOnDiscountCreated
> &
  typeof publicOnDiscountCreated = createEventModule(publicOnDiscountCreated);
/** */
export const onDiscountUpdated: BuildEventDefinition<
  typeof publicOnDiscountUpdated
> &
  typeof publicOnDiscountUpdated = createEventModule(publicOnDiscountUpdated);

export {
  DiscountType,
  FulfillmentType,
  DiscountPlatform,
  DayOfWeek,
  WebhookIdentityType,
} from './restaurants-catalogs-v3-discount-discount.universal.js';
export {
  Discount,
  DiscountValueOneOf,
  DiscountApplyToFilterOneOf,
  Money,
  SectionIds,
  ItemIds,
  DiscountCondition,
  Availability,
  TimePeriod,
  SpecialHourPeriod,
  Coupon,
  GetDiscountRequest,
  GetDiscountResponse,
  UpdateDiscountRequest,
  UpdateDiscountResponse,
  CreateDiscountRequest,
  CreateDiscountResponse,
  ListDiscountsRequest,
  ListDiscountsResponse,
  AddLoyaltyDiscount,
  Empty,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  DiscountCreatedEnvelope,
  DiscountUpdatedEnvelope,
  GetDiscountIdentifiers,
  UpdateDiscountIdentifiers,
  UpdateDiscountOptions,
  CreateDiscountOptions,
  ListDiscountsOptions,
} from './restaurants-catalogs-v3-discount-discount.universal.js';
export {
  DiscountTypeWithLiterals,
  FulfillmentTypeWithLiterals,
  DiscountPlatformWithLiterals,
  DayOfWeekWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './restaurants-catalogs-v3-discount-discount.universal.js';
